var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classCSS,style:({ transform: `rotate(${_vm.angle}deg)` }),attrs:{"data-type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }